import { render, staticRenderFns } from "./LbCheckoutSelect.vue?vue&type=template&id=2d8734be&scoped=true&"
import script from "./LbCheckoutSelect.vue?vue&type=script&lang=js&"
export * from "./LbCheckoutSelect.vue?vue&type=script&lang=js&"
import style0 from "./LbCheckoutSelect.vue?vue&type=style&index=0&id=2d8734be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8734be",
  null
  
)

export default component.exports